// extracted by mini-css-extract-plugin
export default {"kitchen-component-cell":"WbP5JOF71yEO7uB02aEV","modified":"J5PS0zJ3zCJoXANxx05h"};